import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

export class httpInterceptor implements HttpInterceptor {
  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    const auth: HttpRequest<unknown> = request.clone({
      setHeaders: {
        Authorization:
          'Bearer ' + (window.localStorage.getItem('accessToken') ?? ''),
      },
      url: environment.endpoint + request.url,
    });
    return next.handle(auth);
  }
}
